import { render } from "./CompetitorsModalTable.vue?vue&type=template&id=72a0a6da&scoped=true"
import script from "./CompetitorsModalTable.vue?vue&type=script&lang=js"
export * from "./CompetitorsModalTable.vue?vue&type=script&lang=js"

import "./CompetitorsModalTable.vue?vue&type=style&index=0&id=72a0a6da&lang=scss"
import "./CompetitorsModalTable.vue?vue&type=style&index=1&id=72a0a6da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a0a6da"]])

export default __exports__